var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPickaxe = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m712.5 411.37v676.13c0 41.438-33.562 75-75 75h-75c-41.438 0-75-33.562-75-75v-676.13c6.1875 0.75 12.469 1.1719 18.75 1.1719h187.5c6.2812 0 12.562-0.42188 18.75-1.1719zm-345.19-92.297c-93.234 15-186.42 39.141-279.71 72.469-14.391 5.2031-30.469 1.0781-40.641-10.359-10.125-11.391-12.328-27.844-5.5781-41.531 55.828-112.92 174.1-191.06 314.95-232.08-0.046876 1.6406-0.09375 3.2812-0.09375 4.9219v150c0 19.594 3.8438 38.766 11.062 56.578zm476.39-211.18c140.34 41.109 258.42 118.97 314.81 231.52 6.8438 13.734 4.7344 30.188-5.3906 41.672-10.125 11.484-26.203 15.656-40.641 10.5-93.281-32.953-186.61-57.047-279.94-72.141 7.3125-17.906 11.203-37.219 11.203-56.953v-150c0-1.5-0.046875-3.0469-0.046875-4.5938zm-149.95-70.406c19.875 0 38.953 7.9219 53.062 21.984 14.062 14.062 21.938 33.141 21.938 53.016v150c0 19.875-7.875 39-21.938 53.062-14.109 14.062-33.188 21.938-53.062 21.938h-187.5c-19.875 0-38.953-7.875-53.062-21.938-14.062-14.062-21.938-33.188-21.938-53.062v-150c0-19.875 7.875-38.953 21.938-53.016 14.109-14.062 33.188-21.984 53.062-21.984z",
    fill: "#00abe6",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPickaxe);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pickaxe.33c69045c238d3cf229f5ebf8a583400.svg";